<template>
  <div class="header_container" v-if="!isPreview && m_event !== null">
    <div
      class="mask"
      @click="handleNotificationClick()"
      v-if="notificationDisplay"
    ></div>
    <div class="header">
      <div class="toggle-menu">
        <div class="icon" @click.stop="drawer = !drawer">
          <v-icon size="20px" class="btn_item" color="rgb(232, 50, 13)">{{
            menuIcon
          }}</v-icon>
        </div>
        <div class="logo-responsive">
          <router-link :to="pathHome">
            <img :src="m_event !== null ? m_event.logo_img : logoImg" alt />
          </router-link>
        </div>
      </div>

      <div class="redLine"></div>

      <div class="btn_group pt-1">
        <div class="btn_group_sub">
          <div style="position: relative">
            <v-btn
              class="btn_item slash btn_icon"
              text
              color="#fff"
              @click="handleNotificationClick()"
            >
              <v-icon class="btn_item" color="#fff">{{ bellIcon }}</v-icon>
            </v-btn>
            <ListNotification
              v-if="notificationDisplay"
              @updateProps="updateDisplay($event)"
            />
            <p class="number-notification" v-else>
              {{ getTotalUnreadNotification }}
            </p>
          </div>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="btn_item btn_item_dropdown slash"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                v-if="dataLanguage.length > 1"
              >
                {{ select }}

                <v-icon class="icon-language">{{ arrowDown }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in dataLanguage"
                :key="index"
                v-on:click="changeLanguage(item.lang_code, item.lang_name)"
              >
                <v-list-item-title>{{ item.lang_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div class="btn_group_sub btn-sub-logout">
          <v-btn
            class="btn_item btn_logout mx-0"
            text
            color="#fff"
            @click="handleShowDetail"
          >
            {{ $t('header.logout', { split: '/' }) }}
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog">{{
          closeIcon
        }}</v-icon>
        <div class="dialog">
          <h4 v-html="$t('header.notify-logout', { split: '/' })"></h4>
          <v-card-actions>
            <v-btn
              class="btn-logout"
              depressed
              color="#e8320e"
              @click="handleLogout"
            >
              {{ $t('header.btn-logout', { split: '/' }) }}
            </v-btn>

            <v-btn @click="handleCloseDialog" outlined color="#e8320e">
              {{ $t('header.btn-cancer', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="notificationSurveyDialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon
          color="#E8320D"
          class="close-icon"
          @click="handleCloseSurveyNotificationDialog"
          >{{ closeIcon }}</v-icon
        >
        <div class="dialog text-center fix-text">
          <h4 v-html="$t('general.survey-no-access', { split: '</br>' })"></h4>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notificationCheckInDialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon
          color="#E8320D"
          class="close-icon"
          @click="handleCloseCheckInNotificationDialog"
          >{{ closeIcon }}</v-icon
        >
        <div class="dialog text-center fix-text">
          <h4 v-html="$t('general.checkin-no-access', { split: '</br>' })"></h4>
        </div>
      </v-card>
    </v-dialog>
    <div class="mainLogo">
      <div class="logo">
        <!--<router-link :to="pathHome">
          <img v-bind:src="m_event !== null ? m_event.logo_img : logoImg" alt />
        </router-link>-->
        <router-link :to="pathHome" class="home-link">
          <h2>{{ m_event !== null && m_event.event_name }}</h2>
        </router-link>
      </div>
    </div>

    <div :class="[banner == true ? 'banner' : 'banner-basic', bannerImage]">
      <div v-if="menu" class="menu">
        <ul>
          <li :class="{ active: currentRoute == 'top-applicant' }">
            <router-link tag="li" :to="returnUrlPath('/top')">
              TOP
            </router-link>
          </li>
          <li
            :class="{
              active: currentRoute == 'event-schedule'
            }"
            v-if="isDisplayEventSchedulePage"
          >
            <router-link tag="li" :to="returnUrlPath('/event-schedule')">
              <span
                v-html="$t('menu.event-schedule', { split: '<br>' })"
              ></span>
            </router-link>
          </li>
          <li
            :class="{
              active: currentRoute == 'list-company'
            }"
          >
            <router-link tag="li" :to="returnUrlPath('/list-company')">
              <span v-html="$t('menu.list-company', { split: '<br>' })"></span>
            </router-link>
          </li>
          <li
            :class="{ active: currentRoute == 'mail-box' }"
            v-if="isDisplayScoutMailPage"
          >
            <router-link tag="li" :to="returnUrlPath('/mail-box')">
              <span
                v-html="
                  $t('menu.recruitment-letter', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li
            :class="{ active: currentRoute == 'applications' }"
            v-if="isDisplayInterviewlPage"
          >
            <router-link tag="li" :to="returnUrlPath('/applications')">
              <span
                v-html="
                  $t('menu.interview-status', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'my-code' }">
            <router-link tag="li" :to="returnUrlPath('/my-code')">
              <span
                v-html="
                  $t('menu.my-code', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'profile' }">
            <router-link tag="li" :to="returnUrlPath('/profile')">
              <span
                v-html="
                  $t('menu.basic-infomation', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'entrance' }">
            <router-link tag="li" :to="returnUrlPath('/entrance')">
              <span
                v-html="
                  $t('menu.application-info', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'survey' }">
            <span
              @click="handleClickMenuSurvey('/survey')"
              v-html="
                $t('menu.survey', {
                  split: '<br>'
                })
              "
            ></span>
          </li>
          <li :class="{ active: currentRoute == 'company-optionscan' }">
            <span
              @click="handleClickMenuCheckIn('/company-code')"
              v-html="
                $t('menu.company-code', {
                  split: '<br>'
                })
              "
            ></span>
          </li>
        </ul>
      </div>
    </div>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      width="200"
      color="rgba(54, 52, 51, 0.9)"
      class="menu-side-bar"
    >
      <div class="menu-device">
        <ul>
          <li :class="{ active: currentRoute == 'top-applicant' }">
            <router-link tag="li" :to="returnUrlPath('/top')">
              TOP
            </router-link>
          </li>
          <li
            :class="{
              active: currentRoute == 'event-schedule'
            }"
            v-if="isDisplayEventSchedulePage"
          >
            <router-link tag="li" :to="returnUrlPath('/event-schedule')">
              <span
                v-html="$t('menu.event-schedule', { split: '<br>' })"
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'list-company' }">
            <router-link tag="li" :to="returnUrlPath('/list-company')">
              <span v-html="$t('menu.list-company', { split: '<br>' })"></span>
            </router-link>
          </li>
          <li
            :class="{ active: currentRoute == 'mail-box' }"
            v-if="isDisplayScoutMailPage"
          >
            <router-link tag="li" :to="returnUrlPath('/mail-box')">
              <span
                v-html="
                  $t('menu.recruitment-letter', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li
            :class="{ active: currentRoute == 'applications' }"
            v-if="isDisplayInterviewlPage"
          >
            <router-link tag="li" :to="returnUrlPath('/applications')">
              <span
                v-html="
                  $t('menu.interview-status', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'my-code' }">
            <router-link tag="li" :to="returnUrlPath('/my-code')">
              <span
                v-html="
                  $t('menu.my-code', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'profile' }">
            <router-link tag="li" :to="returnUrlPath('/profile')">
              <span
                v-html="
                  $t('menu.basic-infomation', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'entrance' }">
            <router-link tag="li" :to="returnUrlPath('/entrance')">
              <span
                v-html="
                  $t('menu.application-info', {
                    split: '<br>'
                  })
                "
              ></span>
            </router-link>
          </li>
          <li :class="{ active: currentRoute == 'survey' }">
            <span
              @click="handleClickMenuSurvey('/survey')"
              v-html="
                $t('menu.survey', {
                  split: '<br>'
                })
              "
            ></span>
          </li>
          <li :class="{ active: currentRoute == 'company-optionscan' }">
            <span
              @click="handleClickMenuCheckIn('/company-code')"
              v-html="
                $t('menu.company-code', {
                  split: '<br>'
                })
              "
            ></span>
          </li>
        </ul>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  mdiBell,
  mdiFacebook,
  mdiEarth,
  mdiEmail,
  mdiChevronDown,
  mdiMenu,
  mdiClose
} from '@mdi/js';

import { LANG_CODE_JAPANESE, LANG_CODE_VIETNAMESE } from '@/common/constants';
import ListNotification from '@/components/ListNotification';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { Trans } from '@/plugins/translation.js';

export default {
  props: {
    isPreview: {
      default: false
    },
    mEvent: {
      type: Object
    },
    language: {
      type: String,
      default: null
    }
  },

  components: {
    ListNotification
  },

  data: () => ({
    notificationDisplay: false,
    bellIcon: mdiBell,
    fbIcon: mdiFacebook,
    webIcon: mdiEarth,
    mailIcon: mdiEmail,
    menuIcon: mdiMenu,
    closeIcon: mdiClose,
    arrowDown: mdiChevronDown,
    title: 'TOP',
    menu: true,
    bannerImage: '',
    currentRoute: 'homepage',
    select: '',
    isActive: false,

    drawer: null,
    banner: false,
    dialog: false,
    logoImg: `/image/logoMain.svg`,
    notificationSurveyDialog: false,
    notificationCheckInDialog: false
  }),

  watch: {
    '$route.name': function () {
      this.currentRoute = this.$route.name;

      this.initHeader();
    }
  },

  methods: {
    getLanguageFromLS() {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      return objFromLS.sekisho_lang || null;
    },

    setLanguageFromLS(_lang) {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      const newObj = {
        ...objFromLS,
        sekisho_lang: _lang
      };

      localStorage.setItem(keyStore, JSON.stringify(newObj));
    },

    async changeLanguage(lang, title) {
      this.select = title;
      await this.$store.dispatch('changeLanguage', { lang });

      Trans.changeLanguage(lang);
    },

    handleNotificationClick() {
      this.notificationDisplay = !this.notificationDisplay;
    },
    updateDisplay(value) {
      this.notificationDisplay = value;
    },
    initHeader() {
      switch (this.$route.name) {
        case 'top-applicant':
          this.title = 'TOP';
          this.bannerImage = 'top-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'company-detail':
          this.title = 'menu.company-detail';
          this.bannerImage = 'company-detail-page';
          this.menu = false;
          this.banner = false;
          break;
        case 'list-company':
          this.title = 'menu.list-company';
          this.bannerImage = 'list-company-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'mail-box':
          this.title = 'menu.recruitment-letter';
          this.bannerImage = 'mail-box-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'applications':
          this.title = 'menu.recruitment-status';
          this.bannerImage = 'applications-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'profile':
          this.title = 'menu.basic-infomation';
          this.bannerImage = '';
          // this.bannerImage = "profile-page";
          this.menu = true;
          this.banner = false;
          break;
        case 'entrance':
          this.title = 'menu.application-info';
          // this.bannerImage = "entrance-page";
          this.bannerImage = '';
          this.menu = true;
          this.banner = false;
          break;
        case 'my-code':
          this.title = 'menu.my-code';
          this.bannerImage = '';
          // this.bannerImage = "my-code-page";
          this.menu = true;
          this.banner = false;
          break;
        case 'list-company-preview':
          this.title = 'menu.list-company';
          this.bannerImage = 'list-company-page';
          this.menu = true;
          this.banner = true;
          break;
        case 'survey': {
          const checkSurvey = this.checkSurveyDisplay();

          if (!checkSurvey) {
            this.$router.replace({ name: 'top-applicant' }, () => {});
          }

          break;
        }
        case 'company-code':
        case 'company-optionscan':
        case 'company-qrscan':
        case 'company-codescan':
        case 'company-checkin-success': {
          const checkCompanyCheckInDisplay = this.checkCompanyCheckInDisplay();

          if (!checkCompanyCheckInDisplay) {
            this.$router.push({ name: 'top-applicant' }, () => {});
          }
          break;
        }
        case 'event-schedule':
          this.title = 'menu.event-schedule';
          this.bannerImage = '';
          this.menu = true;
          this.banner = false;
          break;
      }
    },

    toggleMenu() {
      this.isActive = !this.isActive;
    },

    checkCurrentLanguage() {
      const { query } = this.$route;

      if (
        query.lang &&
        (query.lang == LANG_CODE_VIETNAMESE || query.lang == LANG_CODE_JAPANESE)
      ) {
        const langActive = this.dataLanguageFromServer.filter(
          (lang) => lang.lang_code === query.lang
        );

        this.select = langActive.length > 0 ? langActive[0].lang_name : '';

        this.changeLanguage(query.lang, this.select);

        return;
      }

      const lang = this.getLanguageFromLS();

      if (lang !== null) {
        const langActive = this.dataLanguageFromServer.filter(
          (language) => language.lang_code === lang
        );

        this.select = langActive.length > 0 ? langActive[0].lang_name : '';
        this.changeLanguage(lang, this.select);
      }
    },

    handleLogout() {
      const key = this.$store.state.contract_id + this.$store.state.event_code;
      const event =
        localStorage.getItem(key) !== null ? localStorage.getItem(key) : null;

      if (event !== null) {
        this.$store.dispatch('logout');
        this.$router.push(this.pathDefault, () => {});
      }
    },

    handleShowDetail() {
      this.dialog = true;
    },

    handleCloseDialog() {
      this.dialog = false;
    },

    handleShowSurveyNotificationDialog() {
      this.notificationSurveyDialog = true;
    },

    handleCloseSurveyNotificationDialog() {
      this.notificationSurveyDialog = false;
    },
    handleShowCheckInNotificationDialog() {
      this.notificationCheckInDialog = true;
    },
    handleCloseCheckInNotificationDialog() {
      this.notificationCheckInDialog = false;
    },
    returnUrlPath(url) {
      const route = this.pathHome + url;

      return route;
    },

    readNoti(item) {
      this.$router.replace(
        { name: 'top-applicant', query: { noti: item.id } },
        () => {}
      );
    },

    readScoutMail(item) {
      this.$router.replace(
        { name: 'mail-box', query: { noti: item.id } },
        () => {}
      );
    },

    getDateFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD');
      }
    },

    getDateTimeFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');
      }
    },

    checkDisplayMenuSurvey(fromData, toData) {
      const now = this.getDateFromUTC();
      const dateFrom = moment(fromData).format('YYYY-MM-DD');
      const dateTo = moment(toData).format('YYYY-MM-DD');

      if (now < dateFrom || now > dateTo) {
        return false;
      } else {
        return true;
      }
    },

    checkDisplayMenuCheckIn(fromData, toData) {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        const dateFrom = moment
          .utc(fromData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const dateTo = moment
          .utc(toData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const now = this.getDateTimeFromUTC();

        if (now < dateFrom || now > dateTo) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },

    checkCompanyCheckInDisplay: function () {
      if (this.m_event !== null) {
        const { event_period_from, event_period_to } = this.m_event;

        if (event_period_from !== null && event_period_to !== null) {
          return this.checkDisplayMenuCheckIn(
            event_period_from,
            event_period_to
          );
        }
      }
      return false;
    },

    checkSurveyDisplay: function () {
      if (this.surveyTemplate !== null) {
        const { applicant_survey_period_from, applicant_survey_period_to } =
          this.surveyTemplate;

        if (
          applicant_survey_period_from !== null &&
          applicant_survey_period_to !== null
        ) {
          return this.checkDisplayMenuSurvey(
            applicant_survey_period_from,
            applicant_survey_period_to
          );
        }
      }
      return false;
    },

    handleClickMenuSurvey(url) {
      if (this.$store) {
        const contractId = this.$store.state.contract_id;
        const eventCode = this.$store.state.event_code;

        const data = {
          event_code: eventCode,
          contract_id: contractId
        };

        const fullPath = location.pathname;

        this.$store
          .dispatch('getEventMasterWhenClickMenu', {
            data,
            fullPath
          })
          .then(() => {
            if (this.checkSurveyDisplay()) {
              this.$router.push({ path: this.returnUrlPath(url) }, () => {});
            } else {
              this.handleShowSurveyNotificationDialog();
            }
          });
      }
    },

    handleClickMenuCheckIn(url) {
      if (this.$store) {
        const contractId = this.$store.state.contract_id;
        const eventCode = this.$store.state.event_code;

        const data = {
          event_code: eventCode,
          contract_id: contractId
        };

        const fullPath = location.pathname;

        this.$store
          .dispatch('getEventMasterWhenClickMenu', {
            data,
            fullPath
          })
          .then(() => {
            if (this.checkCompanyCheckInDisplay()) {
              this.$router.push({ path: this.returnUrlPath(url) }, () => {});
            } else {
              this.handleShowCheckInNotificationDialog();
            }
          });
      }
    }
  },

  created() {
    this.currentRoute = this.$route.name;
    this.initHeader();
    this.checkCurrentLanguage();

    if (this.language) {
      if (this.language === LANG_CODE_VIETNAMESE) {
        this.changeLanguage(LANG_CODE_VIETNAMESE, LANG_VIETNAMESE_TITLE);
      } else {
        this.changeLanguage(LANG_CODE_JAPANESE, LANG_JAPANESE_TITLE);
      }
    }
  },

  computed: {
    ...mapGetters({
      getNotiMail: 'getNotiArray',
      getScoutMail: 'getScoutMailArray',
      m_event: 'getEventData',
      surveyTemplate: 'getMSurveyTemplate',
      getContractId: 'getContractId',
      getEventCode: 'getEventCode'
    }),

    getTotalUnreadNotification() {
      // const total = this.getNotiMail.length + this.getScoutMail.length;
      const total = this.getNotiMail.length;

      return total === 0 ? '' : total;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/components/header.scss';
@import '@/style/devices.scss';

.mask {
  position: absolute;
  background-color: #01010100;
  width: 100vw;
  height: 100%;
  z-index: 1;
}
.number-notification {
  position: absolute;
  font-weight: bold;
  top: 22px;
  left: 22px;
  font-size: 1rem;
  background-color: #f02849;
  padding: 0rem 0.5rem;
  border-radius: 46rem;
}
@include tablet {
  .number-notification {
    top: 18px;
    left: 2px;
    font-size: 0.8rem;
    padding: 0rem 0.4rem;
  }
}
@include mobile {
  .number-notification {
  }

  .fix-text {
    h4 {
      font-size: 13px !important;
    }
  }
}
@include small-mobile {
  .number-notification {
  }
  .fix-text {
    h4 {
      font-size: 12px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.mainLogo {
  min-height: 90px !important;
  .logo h2 {
    max-width: 85vw !important;
  }

  .logo:not(:has(img)) h2 {
    padding-left: 10px !important;
    max-width: 90vw !important;
  }
}
</style>
